module.exports = __webpack_public_path__ + "454868025694141663f98aece07fd47c.jpg";